export const sources = {
	webp: "__VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 400w, __VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 800w"
};
export const img = {
	src: "__VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
